export default __webpack_public_path__ + "static/media/cancel_icon.622fc0cd.svg";